<template>
  <div class="app" :class="{ mobile: mobileView }">
    <!-- ✅ MOBILE VIEW -->
    <template v-if="mobileView">
      <!-- BÀN -->
      <div v-show="activeTab === 'tables'" class="mobile-tab">
        <div class="card">
          <div style="display:flex;justify-content:space-between;align-items:center">
            <strong>Bàn / Khu vực</strong>
            <button class="btn ghost" @click="createNewTable">Tạo bàn</button>
          </div>
          <div style="margin-top:8px">
            <input v-model="searchTable" placeholder="Tìm bàn..."
                   style="width:100%;padding:8px;border-radius:8px;border:1px solid #eee"/>
          </div>
          <div class="tables">
            <div v-for="t in filteredTables" :key="t.id"
                 class="table"
                 :class="[{ active: selectedTableID === t.id }, 'status-' + (t.status || 0)]"
                 @click="selectTable(t)">
              {{ t.name }}
            </div>
          </div>
        </div>
      </div>

      <!-- MENU -->
      <div v-show="activeTab === 'menu'" class="mobile-tab">
        <div class="card center-header">
          <div style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:8px">
            <div>
              <h3>Menu gọi món</h3>
              <div style="color:var(--muted);font-size:13px">
                {{ selectedTable.name || 'Chưa chọn bàn' }}
              </div>
            </div>
            <div style="display:flex;gap:6px;flex-wrap:wrap">
              <button class="btn ghost" @click="showAddFood = true">➕ Thêm món</button>
              <button class="btn ghost" @click="showAddCategory = true">📂 Thêm danh mục</button>
            </div>
          </div>

          <!-- Thanh tìm kiếm -->
          <div class="search" style="margin-top:10px">
            <input v-model="search" placeholder="Tìm món, mã, mô tả..."/>
            <button class="btn ghost" @click="search = ''">X</button>
          </div>

          <!-- Danh mục -->
          <div class="categories" style="margin-top:10px;display:flex;flex-wrap:wrap;gap:6px">
            <div
                v-for="cat in categories"
                :key="cat.id"
                class="cat"
                :class="{ active: selectedCategory === cat.name }"
                @click="selectedCategory = cat.name"
                style="padding:6px 10px;border-radius:20px;border:1px solid #eee;cursor:pointer;font-size:13px"
            >
              {{ cat.name }}
            </div>
          </div>
        </div>

        <!-- Danh sách món -->
        <div class="card" style="flex:1;overflow:auto;padding:12px;margin-top:10px">
          <div class="foods">
            <div v-for="food in filteredFoods" :key="food.id" class="food" :class="{ selected: getQty(food.id) > 0 }"
                 @click="add(food)">
              <div class="name" style="text-align: center;">{{ food.name }}</div>
              <div class="meta" style="text-align: center;">Mã: {{ food.id }}</div>
              <div class="price" style="text-align: center;">{{ formatMoney(food.price) }}</div>
              <div v-if="getQty(food.id) > 0" class="qty-badge">
                {{ getQty(food.id) }}
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- CART -->
      <div v-show="activeTab === 'cart'" class="mobile-tab">
        <div class="card">
          <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:12px">
            <div>
              <strong>Hóa đơn</strong>
              <div style="color:var(--muted);font-size:13px;margin-top:4px">
                Trạng thái: <span>Mới</span>
              </div>
            </div>
            <div style="text-align:right">
              <div style="color:var(--muted);font-size:13px">
                <span>{{ selectedTable.name || '-' }}</span>
              </div>
              <button @click="openTransferModal"
                      style="margin-top:8px;padding:6px 12px;background-color:#ff6b35;color:white;border:none;border-radius:6px;cursor:pointer;font-size:13px;font-weight:600">
                Chuyển bàn
              </button>
            </div>
          </div>
        </div>

        <div class="card cart-list">
          <div v-if="cart.length === 0" style="padding:12px;color:var(--muted)">Chưa có món nào</div>
          <div
              v-for="(ci,i) in cart"
              :key="i"
              class="cart-item-wrapper"
              @touchstart="onTouchStart($event, i)"
              @touchmove="onTouchMove($event, i)"
          >

            <!-- Nút xoá -->
            <div class="delete-btn" @click="removeItem(i)">
              Xoá
            </div>

            <!-- Content -->
            <div class="cart-item" :class="{ swipe: swipeIndex === i }">

              <div style="flex:1">
                <div style="font-weight:600">{{ ci.name }}</div>

                <input v-model="ci.note" placeholder="Ghi chú..."
                       style="width:100%;margin-top:6px;padding:6px;border-radius:6px;border:1px solid #eee;font-size:13px"/>
              </div>

              <div style="text-align:right">
                <div style="font-weight:700">
                  {{ formatMoney(ci.price * ci.qty) }}
                </div>

                <div class="qty">
                  <button @click="changeQty(ci.foodId,-1)">-</button>
                  <span>{{ ci.qty }}</span>
                  <button @click="changeQty(ci.foodId,1)">+</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- Sticky Cart Bottom - chỉ hiển thị khi ở tab cart -->
      <div v-show="activeTab === 'cart'" class="sticky-cart-bottom">
        <div class="card cart-bottom">

          <!-- Tổng tiền -->
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px">
            <div style="color:var(--muted);font-size:17px">Tổng tiền</div>
            <div style="font-size:18px;font-weight:700">{{ formatMoney(total) }}</div>
          </div>


          <!-- 3 nút nằm ngang -->
          <div style="display:flex;gap:8px;margin-bottom:10px">
            <button
                :disabled="isProcessing"
                v-if="!currentOrder"
                class="btn"
                @click="checkout"
                style="background-color:#111;font-size:18px;flex:1">
              Gọi món
            </button>

            <button

                class="btn"
                @click="openPaymentModal"
                style="background-color:#111;font-size:18px;flex:1">
              Thanh toán
            </button>

            <button
                class="btn"
                @click="updateCart"
                style="background-color:#111;font-size:18px;flex:1">
              Thay đổi
            </button>
          </div>

          <!-- ghi chú -->
          <div style="display:flex;gap:8px;align-items:center">
            <input
                v-model="note"
                placeholder="Ghi chú (vd: ít ngọt)"
                style="flex:1;padding:8px;border-radius:8px;border:1px solid #eee"
            />
            <button class="btn ghost" @click="clearCart">Xóa</button>
          </div>

        </div>
      </div>

      <!-- Bottom Navbar -->
      <div class="mobile-nav">
        <button :class="{active: activeTab==='tables'}" @click="activeTab='tables'"
                style="font-size: 20px">🪑 Bàn
        </button>
        <button :class="{active: activeTab==='menu'}" @click="activeTab='menu'"
                style="font-size: 20px"> 🍜 Món
        </button>
        <button :class="{active: activeTab==='cart'}" @click="activeTab='cart'"
                style="font-size: 20px"> 💵 Hóa đơn
        </button>
      </div>
    </template>

    <!-- AddFood Popup -->
    <div v-if="showAddFood" class="modal-overlay" @click.self="showAddFood = false"
         style="position:fixed;inset:0;display:flex;align-items:center;justify-content:center;z-index:1000;background:rgba(0,0,0,.25)">
      <div class="modal-content" style="background:#fff;border-radius:12px;padding:20px;min-width:320px">
        <AddFood @food-added="onFoodAdded" @close="showAddFood = false"/>
      </div>
    </div>

    <!-- AddCategory Popup -->
    <div v-if="showAddCategory" class="modal-overlay" @click.self="showAddCategory = false"
         style="position:fixed;inset:0;display:flex;align-items:center;justify-content:center;z-index:1000;background:rgba(0,0,0,.25)">
      <div class="modal-content" style="background:#fff;border-radius:12px;padding:20px;min-width:320px">
        <h4>➕ Thêm danh mục mới</h4>
        <input v-model="newCategory" placeholder="Tên danh mục"
               style="margin-bottom:12px;width:100%;padding:8px;border-radius:8px;border:1px solid #eee"/>
        <div style="display:flex;gap:8px">
          <button class="btn" style="background-color: #00cec9; color: white" @click="addCategory">Thêm</button>
          <button class="btn ghost" @click="showAddCategory = false">Huỷ</button>
        </div>
      </div>
    </div>

    <!-- AddTable Popup -->
    <div v-if="showAddTable" class="modal-overlay" @click.self="showAddTable = false"
         style="position:fixed;inset:0;display:flex;align-items:center;justify-content:center;z-index:1000;background:rgba(0,0,0,.25)">
      <div class="modal-content" style="background:#fff;border-radius:12px;padding:20px;min-width:320px">
        <h4>➕ Tạo bàn mới</h4>
        <input v-model="newTableName" placeholder="Tên bàn (vd: Bàn 1)"
               style="margin-bottom:12px;width:100%;padding:8px;border-radius:8px;border:1px solid #eee"/>
        <div style="display:flex;gap:8px">
          <button class="btn" style="background-color: #00cec9; color: white" @click="addTable">Tạo</button>
          <button class="btn ghost" @click="showAddTable = false">Huỷ</button>
        </div>
      </div>
    </div>

    <!-- Transfer Table Modal -->
    <div v-if="showTransferModal" class="modal-overlay" @click.self="showTransferModal = false"
         style="position:fixed;inset:0;display:flex;align-items:center;justify-content:center;z-index:1000;background:rgba(0,0,0,.25)">
      <div class="modal-content" style="background:#fff;border-radius:12px;padding:20px;min-width:350px">
        <h4>🔄 Chuyển bàn</h4>
        <p style="color:var(--muted);font-size:13px;margin-bottom:12px">Chọn bàn để chuyển đơn hiện tại</p>
        <div style="max-height:300px;overflow:auto;border:1px solid #eee;border-radius:8px;padding:8px">
          <div v-for="t in tables" :key="t.id"
               style="padding:10px;border-radius:6px;cursor:pointer;margin-bottom:6px;border:2px solid;font-weight:500;transition:all 0.2s"
               :style="{ backgroundColor: transferTableToId === t.id ? '#d4edda' : '#fff', borderColor: transferTableToId === t.id ? '#28a745' : '#eee' }"
               @click="transferTableToId = t.id">
            {{ t.name }}
          </div>
        </div>
        <div style="display:flex;gap:8px;margin-top:12px">
          <button class="btn" style="background-color: #ff6b35; color: white;flex:1" @click="confirmTransfer">Chuyển
          </button>
          <button class="btn ghost" @click="showTransferModal = false;transferTableToId = null">Huỷ</button>
        </div>
      </div>
    </div>

    <!-- Payment Method Modal -->
    <div v-if="showPaymentModal" class="modal-overlay" @click.self="showPaymentModal = false"
         style="position:fixed;inset:0;display:flex;align-items:center;justify-content:center;z-index:1000;background:rgba(0,0,0,.25)">
      <div class="modal-content" style="background:#fff;border-radius:12px;padding:20px;min-width:320px">
        <h4>💳 Chọn phương thức thanh toán</h4>
        <div style="display:flex;flex-direction:column;gap:10px;margin-top:15px">
          <button
              @click="confirmPayment('cash')"
              style="padding:12px;background-color:#52c41a;color:white;border:none;border-radius:8px;font-weight:600;cursor:pointer;font-size:16px">
            💵 Tiền mặt
          </button>
          <button
              @click="confirmPayment('transfer')"
              style="padding:12px;background-color:#1890ff;color:white;border:none;border-radius:8px;font-weight:600;cursor:pointer;font-size:16px">
            🏦 Chuyển khoản
          </button>
          <button
              @click="showPaymentModal = false"
              class="btn ghost"
              style="padding:12px">
            Huỷ
          </button>
        </div>
      </div>
    </div>

    <!-- Serve Item Modal -->
    <div v-if="showServeItemModal" class="modal-overlay" @click.self="showServeItemModal = false"
         style="position:fixed;inset:0;display:flex;align-items:center;justify-content:center;z-index:1000;background:rgba(0,0,0,.25)">
      <div class="modal-content" style="background:#fff;border-radius:12px;padding:20px;min-width:350px">
        <h4>🍴 Lên món</h4>
        <p style="color:var(--muted);font-size:13px;margin-bottom:12px">Chọn các món đã xong để lên phục vụ</p>
        <div style="max-height:300px;overflow:auto;border:1px solid #eee;border-radius:8px;padding:8px">
          <div v-for="item in cart" :key="item.id"
               style="padding:10px;border-radius:6px;cursor:pointer;margin-bottom:6px;border:2px solid;font-weight:500;transition:all 0.2s;display:flex;align-items:center;gap:8px"
               :style="{ backgroundColor: serveItems.includes(item.id) ? '#d4edda' : '#fff', borderColor: serveItems.includes(item.id) ? '#28a745' : '#eee' }"
               @click="toggleServeItem(item.id)">
            <input type="checkbox" :checked="serveItems.includes(item.id)" style="cursor:pointer"/>
            <span>{{ item.name }} x{{ item.qty }}</span>
          </div>
        </div>
        <div style="display:flex;gap:8px;margin-top:12px">
          <button class="btn" style="background-color: #52c41a; color: white;flex:1" @click="confirmServeItems">Lên
            món
          </button>
          <button class="btn ghost" @click="showServeItemModal = false">Huỷ</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import {ref, computed, onMounted, onBeforeUnmount} from 'vue'
import {getCategory, getFoods, getTable, createCat, createTable} from '../services/foods.js'
import {
  createOrder,
  getOrdersByTable,
  paymentOrder,
  updateOrder,
  transferTable,
  serveItem,
  deleteOrderItem
} from '../services/orders.js'
import AddFood from './AddFood.vue'
import SockJS from 'sockjs-client'
import {Client} from '@stomp/stompjs'

let stompClient = null

const foods = ref([])
const tables = ref([])
const cart = ref([])
const originalCart = ref([])

const search = ref('')
const note = ref('')
const selectedCategory = ref('Tất cả')
const categories = ref([])

const selectedTable = ref([])
const selectedTableID = ref(null)

const searchTable = ref('')
const showAddFood = ref(false)
const showAddCategory = ref(false)
const showAddTable = ref(false)
const showTransferModal = ref(false)
const showPaymentModal = ref(false)
const showServeItemModal = ref(false)

const currentOrder = ref(null)

const newCategory = ref('')
const newTableName = ref('')
const transferTableToId = ref(null)
const serveItems = ref([])
const selectedPaymentMethod = ref(null)

const mobileView = ref(true)
const activeTab = ref('tables')

const swipeIndex = ref(null)
const startX = ref(0)

function handleResize() {
  mobileView.value = window.innerWidth < 2400
}

function isCartChanged() {
  return JSON.stringify(cart.value) !== JSON.stringify(originalCart.value)
}

onMounted(async () => {
  foods.value = await getFoods()
  categories.value = await getCategory()
  tables.value = await getTable()

  handleResize()
  window.addEventListener('resize', handleResize)

  stompClient = new Client({
    webSocketFactory: () => new SockJS('/ws'),
    // reconnectDelay: 5000,
    onConnect: () => {
      console.log("WS connected (tables)")
      console.log("WS EVENT TRIGGERED", new Date())
      stompClient.subscribe('/topic/orders', async () => {
        try {
          console.log("WS: orders topic event, reloading tables...")
          // Luôn làm mới danh sách bàn
          tables.value = await getTable()

          // Nếu không có bàn đang chọn thì thôi
          if (!selectedTableID.value) return

          // Lấy orders của bàn đang chọn từ server
          const orders = await getOrdersByTable(selectedTableID.value)
          const pendingOrder = orders.find(o => o.status === '0')

          if (!pendingOrder) {
            if (!isCartChanged()) {
              currentOrder.value = null
              cart.value = []
              originalCart.value = []
              note.value = ''
              if (mobileView.value) activeTab.value = 'tables'
            } else {
              console.log('WS: server removed order but local cart has unsaved changes; keeping local cart.')

            }
            return
          }

          // Nếu có pending order:
          // Nếu local cart đang thay đổi -> không ghi đè (tránh mất data người dùng)
          if (isCartChanged()) return

          // An toàn để đồng bộ: cập nhật currentOrder và cart theo server
          currentOrder.value = pendingOrder
          cart.value = mapOrderItemsToCartItems(pendingOrder)
          originalCart.value = JSON.parse(JSON.stringify(cart.value))
          note.value = pendingOrder.note || ''

          // nếu cần, chuyển view sang cart trên mobile
          if (mobileView.value) activeTab.value = 'cart'
        } catch (err) {
          console.error('WS subscribe handling error', err)
        }
      })
    }
  })

  stompClient.activate()
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
  // Deactivate WebSocket client when component is destroyed
  try {
    if (stompClient) stompClient.deactivate()
  } catch (e) {
    console.error('Error deactivating stomp client', e)
  }
})

async function removeItem(index) {
  try {
    const item = cart.value[index]

    if (currentOrder.value) {
      await deleteOrderItem(item.id) // ✅ đúng ID
    }

    cart.value.splice(index, 1)

  } catch (e) {
    console.error("Delete item error", e)
    alert("Không xoá được món")
  }
}

const filteredTables = computed(() =>
    tables.value.filter(t =>
        t.name.toLowerCase().includes(searchTable.value.toLowerCase())
    )
)

const filteredFoods = computed(() => {
  return foods.value.filter(f => {
    const matchSearch =
        f.name.toLowerCase().includes(search.value.toLowerCase())

    const matchCat =
        selectedCategory.value === 'Tất cả' ||
        f.category?.name === selectedCategory.value

    return matchSearch && matchCat
  })
})

function mapOrderItemsToCartItems(order) {
  return order.items.map(item => ({
    id: item.id,              // ✅ orderItemId
    foodId: item.food.id,     // (nếu cần dùng riêng)
    name: item.food.name,
    price: item.price,
    qty: item.qty,
    note: item.note
  }))
}

async function selectTable(t) {
  selectedTable.value = t
  selectedTableID.value = t.id

  try {
    const orders = await getOrdersByTable(t.id)

    const pendingOrder = orders.find(o => o.status === '0')

    if (pendingOrder) {
      currentOrder.value = pendingOrder

      cart.value = mapOrderItemsToCartItems(pendingOrder)

      // snapshot cart ban đầu
      originalCart.value = JSON.parse(JSON.stringify(cart.value))

      note.value = pendingOrder.note || ''
    } else {
      currentOrder.value = null
      cart.value = []
      originalCart.value = []
      note.value = ''
    }
  } catch (e) {
    console.error(e)
  }

  if (mobileView.value) {
    activeTab.value = currentOrder.value ? 'cart' : 'menu'
  }
}


// const cartChanged = computed(() => {
//   return JSON.stringify(cart.value) !== JSON.stringify(originalCart.value)
// })

function add(food) {
  if (!selectedTableID.value)
    return alert('Vui lòng chọn bàn trước khi gọi món.')

  const item = cart.value.find(i => i.foodId === food.id)

  if (item) item.qty++
  else cart.value.push({
    foodId: food.id,
    name: food.name,
    price: food.price,
    qty: 1
  })
}

function getQty(foodId) {
  const item = cart.value.find(i => i.foodId === foodId)
  return item ? item.qty : 0
}

function changeQty(foodId, delta) {
  const it = cart.value.find(c => c.foodId === foodId)

  if (!it) return

  it.qty += delta

  if (it.qty <= 0) {
    cart.value = cart.value.filter(c => c.foodId !== foodId)
  }
  console.log("line 507: " + cart.value)
}

function clearCart() {
  if (confirm('Xóa toàn bộ món?')) cart.value = []
}

async function updateCart() {

  if (!currentOrder.value) return

  const payload = {
    items: cart.value.map(item => ({
      foodId: item.foodId,
      qty: item.qty,
      note: item.note
    })),
    note: note.value,
    tableId: selectedTableID.value
  }
  console.log(cart.value)
  console.log(payload)

  try {
    await updateOrder(currentOrder.value.id, payload)

    originalCart.value = JSON.parse(JSON.stringify(cart.value))

    // //alert('Cập nhật thành công!')
  } catch (e) {
    console.error('Error updating order:', e)
    //alert('Có lỗi khi cập nhật đơn hàng. Vui lòng thử lại.')
  }
}

const isProcessing = ref(false)

async function checkout() {
  if (isProcessing.value) return
  if (cart.value.length === 0) return

  isProcessing.value = true

  try {
    const orderData = {
      tableId: selectedTableID.value,
      items: cart.value.map(item => ({
        foodId: item.foodId,
        qty: item.qty,
        price: item.price,
        note: item.note,
      })),
      note: note.value
    }

    await createOrder(orderData)

    cart.value = []
    note.value = ''

    // ✅ update tables ngay
    tables.value = await getTable()

    if (stompClient && stompClient.connected) {
      stompClient.publish({
        destination: '/topic/orders',
        body: JSON.stringify({
          type: 'create',
          tableId: selectedTableID.value
        })
      })
    }
    tables.value = await getTable();
  } catch (e) {
    console.error(e)
  } finally {
    isProcessing.value = false
  }
}

const total = computed(() =>
    cart.value.reduce((s, c) => s + c.price * c.qty, 0)
)

function createNewTable() {
  showAddTable.value = true
}

function formatMoney(n) {
  return n.toLocaleString('vi-VN') + '₫'
}

async function onFoodAdded() {
  showAddFood.value = false

  foods.value = await getFoods()

  categories.value = await getCategory()
}

async function addCategory() {
  const name = (newCategory.value || '').trim()

  if (!name) {
    //alert('Vui lòng nhập tên danh mục!')
    return
  }

  if (categories.value.some(c => c.name === name)) {
    //alert('Danh mục đã tồn tại!')
    return
  }

  try {
    await createCat({name})

    newCategory.value = ''
    showAddCategory.value = false

    categories.value = await getCategory()
  } catch (e) {
    console.error('Error creating category', e)
    //alert('Có lỗi khi tạo danh mục.')
  }
}

async function addTable() {
  const name = (newTableName.value || '').trim()

  if (!name) {
    //alert('Vui lòng nhập tên bàn!')
    return
  }

  try {
    const payload = {
      name,
      status: "0",
      createdAt: new Date().toISOString()
    }

    await createTable(payload)

    newTableName.value = ''
    showAddTable.value = false

    tables.value = await getTable()
  } catch (e) {
    console.error('Error creating table', e)
    //alert('Có lỗi khi tạo bàn.')
  }
}

function openTransferModal() {
  if (!currentOrder.value) {
    return alert('Chưa có đơn để chuyển bàn.')
  }
  showTransferModal.value = true
}

async function confirmTransfer() {
  if (!transferTableToId.value) {
    return alert('Vui lòng chọn bàn để chuyển.')
  }

  if (transferTableToId.value === selectedTableID.value) {
    return alert('Vui lòng chọn bàn khác.')
  }

  try {
    await transferTable(currentOrder.value.id, transferTableToId.value)

    showTransferModal.value = false
    transferTableToId.value = null

    // Reload tables and clear current order
    tables.value = await getTable()
    cart.value = []
    note.value = ''
    currentOrder.value = null
    selectedTableID.value = null
    selectedTable.value = {}

    if (mobileView.value) {
      activeTab.value = 'tables'
    }

  } catch (e) {
    console.error('Error transferring table', e)
    alert('Có lỗi khi chuyển bàn. Vui lòng thử lại.')
  }
}

function openPaymentModal() {
  if (!currentOrder.value) return alert('Không có đơn để thanh toán.')
  showPaymentModal.value = true
}

async function confirmPayment(method) {
  selectedPaymentMethod.value = method
  showPaymentModal.value = false

  await paymentOrder(currentOrder.value.id, 1, method)

  cart.value = []
  note.value = ''
  currentOrder.value = null
  tables.value = await getTable()
  // Notify other clients via WebSocket so they can refresh table/order state
  try {
    if (stompClient && stompClient.connected) {
      stompClient.publish({
        destination: '/topic/orders',
        body: JSON.stringify({
          type: 'payment', tableId: selectedTableID.value
        })
      })
    }
  } catch (e) {
    console.error('WS publish error after payment', e)
  }
  activeTab.value = 'tables'
}

function toggleServeItem(itemId) {
  const index = serveItems.value.indexOf(itemId)
  if (index > -1) {
    serveItems.value.splice(index, 1)
  } else {
    serveItems.value.push(itemId)
  }
}

async function confirmServeItems() {
  if (serveItems.value.length === 0) return alert('Vui lòng chọn ít nhất một món')

  try {
    for (const itemId of serveItems.value) {
      await serveItem(currentOrder.value.id, itemId)
    }

    showServeItemModal.value = false
    serveItems.value = []

    // Reload current order to update status
    const orders = await getOrdersByTable(selectedTableID.value)
    const pendingOrder = orders.find(o => o.status === '0')

    if (pendingOrder) {
      currentOrder.value = pendingOrder
      cart.value = mapOrderItemsToCartItems(pendingOrder)
      originalCart.value = JSON.parse(JSON.stringify(cart.value))
    }
  } catch (e) {
    console.error('Error serving items:', e)
    alert('Có lỗi khi lên món. Vui lòng thử lại.')
  }
}

function onTouchStart(e) {
  startX.value = e.touches[0].clientX
}

function onTouchMove(e, index) {
  const moveX = e.touches[0].clientX
  const diff = startX.value - moveX

  if (diff > 50) {
    swipeIndex.value = index // mở
  }

  if (diff < -30) {
    swipeIndex.value = null // đóng
  }
}

</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap');

:root {
  --accent: #ff6b35;
  --bg: #f6f6f8;
  --card: #ffffff;
  --muted: #777;
}

* {
  box-sizing: border-box;
  font-family: Inter, ui-sans-serif, system-ui;
}

body {
  margin: 0;
  background: var(--bg);
  color: #111;
}

/* Ô tìm món */
.search input {
  width: 100%;
  padding: 10px 36px 10px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' stroke='%23777' stroke-width='2' viewBox='0 0 24 24'%3E%3Ccircle cx='11' cy='11' r='8'/%3E%3Cline x1='21' y1='21' x2='16.65' y2='16.65'/%3E%3C/svg%3E") no-repeat right 10px center;
  background-size: 18px;
  transition: all 0.2s ease;
}

.search input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(255, 107, 53, 0.15);
}

.search {
  position: relative;
  display: flex;
  align-items: center;
}

.search .btn.ghost {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  color: #999;
  padding: 4px 8px;
  cursor: pointer;
}

.search .btn.ghost:hover {
  color: var(--accent);
}

.app {
  display: grid;
  grid-template-columns:300px 1fr 380px;
  gap: 18px;
  height: 100vh;
  padding: 18px;
}

.left {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.card {
  background: var(--card);
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 6px 18px rgba(16, 24, 40, 0.06);
}

.tables {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.table {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 70px; /* 👈 cao hơn */
  padding: 14px;
  border-radius: 12px;
  border: 1px solid #eee;
  font-size: 16px; /* 👈 chữ to hơn */
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  user-select: none;
}

.table:active {
  transform: scale(0.97); /* 👈 hiệu ứng bấm */
}

.table.active {
  background: #222;
  color: #fff;
}

.table.status-0 {
  background: #fff;
  color: #222;
}

.table.status-1 {
  background: #ff4d4f; /* đỏ dịu hơn */
  color: #fff;
}

.table.status-2 {
  background: #52c41a; /* xanh dịu hơn */
  color: #fff;
}

.foods {
  display: grid;
  grid-template-columns:repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
}

.food {
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
  transition: .2s;
  position: relative;
}

.food:hover {
  background: #fafafa;
}

.food.selected {
  background-color: #e6f7ff;
  border-color: #1890ff;
}

.qty-badge {
  position: absolute;
  top: 5px;
  right: 5px;
  background: #ff4d4f;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
}

.cart-list {
  flex: 1;
  overflow: auto;
  max-height: 300px;
}

.cart-item {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  border-bottom: 1px solid #eee;
  padding: 8px 0;
}

.qty {
  display: flex;
  gap: 6px;
  align-items: center;
}

.qty button {
  border: none;
  background: #ddd;
  border-radius: 6px;
  width: 24px;
  height: 24px;
}

.btn {
  border: none;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  background: var(--accent);
  color: #fff;
}

.btn.ghost {
  background: transparent;
  color: #333;
  border: 1px solid #eee;
}

.mobile-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: space-around;
  padding: 6px 0;
}

.mobile-nav button {
  flex: 1;
  background: none;
  border: none;
  padding: 8px;
  font-size: 15px;
}

.mobile-nav button.active {
  color: var(--accent);
  font-weight: 700;
}

.mobile-tab {
  padding-bottom: 60px;
}

.sticky-cart-bottom {
  position: fixed;
  bottom: 60px; /* Cao của bottom nav */
  left: 0;
  right: 0;
  background: #fff;
  border-top: 1px solid #ddd;
  padding: 10px 8px; /* Padding ngang bằng với app padding */
  z-index: 100;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); /* Shadow để nổi bật */
}

@media (max-width: 768px) {
  .app.mobile {
    display: block;
    padding: 8px;
    height: auto;
  }
}

/* minimal modal helpers (optional, inline styles used above) */
.modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  background: rgba(0, 0, 0, .25);
}

.modal-content {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  min-width: 320px;
}

.cart-item-wrapper {
  position: relative;
  overflow: hidden;
}

.delete-btn {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 70px;
  background: #ff4d4f;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.cart-item {
  background: white;
  position: relative;
  transition: transform 0.25s ease;
  z-index: 2;
}

.cart-item.swipe {
  transform: translateX(-70px);
}
</style>
